import Vue from 'vue'
import { generateReport } from '@/api/Topup/topup.api'
import { formatDate } from '../functions'
import { Params } from '../interfaces'

export const reportMixin = Vue.extend({
  methods: {
    async generateReport(filter: Params) {
      const link = document.createElement('a')
      const response = await this.reportGetter(filter)
      const blob = new Blob([response.data], {
        type: response.headers['Content-Type'],
      })
      link.href = URL.createObjectURL(blob)
      link.target = '_blank'
      link.download =
        this.$t('reports') +
        '-' +
        formatDate(new Date().toISOString()) +
        (this.$p.isIntegration ? '.csv' : '.xls')
      link.click()
    },
    reportGetter: generateReport,
  },
})
